import {extractFormErrorsFromResponse, putAll, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {
    buildSubjectManagementCenterOptions,
    BuildSubjectManagementCenters,
} from 'app/admin/model/sagas/build-subject-management-center-options';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {managementOrganizationFormName} from '../../types/management-organization-form-values';
import {adminAction, UpdateManagementOrganizationDetailAction} from '../action';

const te = t('common');
const title = te('updateEntry');

function* execute({payload: {organizationId}}: UpdateManagementOrganizationDetailAction): SagaIterator {
    const formValues = yield* select(formHelpers.formValues(managementOrganizationFormName));
    yield* put(formHelpers.startSubmit(managementOrganizationFormName));

    const buildFarms: BuildSubjectManagementCenters = {
        centerIds: formValues.prop('farmIds').orNull(),
        type: 'MANAGEMENT_ORGANIZATION_FARM',
    };
    const computedFarmIds = yield* call(buildSubjectManagementCenterOptions, buildFarms);

    const buildCenters: BuildSubjectManagementCenters = {
        centerIds: formValues.prop('organizationCenterIds').orNull(),
        type: 'MANAGEMENT_ORGANIZATION_CENTER',
    };
    const computedCenterIds = yield* call(buildSubjectManagementCenterOptions, buildCenters);

    const response = yield* call(Api.updateUserProfileOrganizationRoleBySubjectManager, {
        approvedTo: formValues.prop('approvedTo').orNull(),
        userProfileOrganizationRoleId: formValues
            .prop('userProfileOrganizationRoleId').orCrash('No userProfileOrganizationRoleId found'),
        farmIds: computedFarmIds,
        organizationCenterIds: computedCenterIds,
    });

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOrganizationsTableData(opt({action: 'refresh'}), organizationId));
        yield* put(showSuccess(title, te('updateEntrySuccess'), false, 'updateManagementOrganization'));
        yield* put(adminAction.setManagementSubjectModalVisible(null));
        yield* put(formHelpers.reset(managementOrganizationFormName));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(managementOrganizationFormName, extractFormErrorsFromResponse(response)));
    }
}
/** Runs the admin saga that updates the selected organization-management binding. */
export function* updateManagementOrganizationDetailSaga(): SagaIterator {
    yield takeLatestF('admin/UPDATE_MANAGEMENT_ORGANIZATION_DETAIL', execute);
}
